module.exports = __webpack_public_path__ + "static/media/slide2.0ec5fbb1.jpg";